import React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import styles from "./DetailTable.module.scss";
import Detail from "../Detail/Detail";

export interface DetailTableProps extends React.HTMLAttributes<HTMLTableElement> {
    children: React.ReactNode;
}

const DefaultDetailTable = (props: DetailTableProps) => {
    const { className, children, ...otherProps } = props;
    return (
        <table className={clsx(styles.detailTable, className)} data-deci-detail-table="true" {...otherProps}>
            <tbody>
                {children}
            </tbody>
        </table>
    );
};

const DetailTable = createPluggable<DetailTableProps>("deci.detailTable", DefaultDetailTable);

const DefaultDetailTableRow = (props: React.ComponentProps<typeof Detail>) => {
  return <Detail as="tr" {...props} />;
};

const DetailTableRow = createPluggable<React.ComponentProps<typeof Detail>>(
  "deci.detailTable.row",
  DefaultDetailTableRow,
);

const DefaultDetailTableIcon = (props: React.ComponentProps<typeof Detail.Icon>) => {
  return <Detail.Icon as="td" {...props} />;
};

const DetailTableIcon = createPluggable<React.ComponentProps<typeof Detail.Icon>>(
  "deci.detailTable.icon",
  DefaultDetailTableIcon,
);

const DefaultDetailTableTitle = (props: React.ComponentProps<typeof Detail.Title>) => {
  return <Detail.Title as="td" {...props} />;
};

const DetailTableTitle = createPluggable<React.ComponentProps<typeof Detail.Title>>(
  "deci.detailTable.title",
  DefaultDetailTableTitle,
);

const DefaultDetailTableContent = (props: React.ComponentProps<typeof Detail.Content>) => {
  return <Detail.Content as="td" {...props} />;
};

const DetailTableContent = createPluggable<React.ComponentProps<typeof Detail.Content>>(
  "deci.detailTable.content",
  DefaultDetailTableContent,
);

export default Object.assign(DetailTable, {
  Item: DetailTableRow,
  Icon: DetailTableIcon,
  Title: DetailTableTitle,
  Content: DetailTableContent,
});
